import styled from 'styled-components';
import tw from 'twin.macro';
import { Body } from '../../../../styled components/Typography';
import UICard from '../../../../styled components/UICard';
import {
  deletedText,
  pastRow,
  statusBackground
} from '../../ListViewBookings/ListViewBookings.style';
import type { RowDisplayStatus } from '../../../listViewRowStatus';

/* The card one booking is presented on in the card view. The surface itself is
 * also what ListViewCardsLoading draws its skeletons on, so the cards that are
 * still loading have the size and the spacing of the ones that arrive. */

export const BookingCard = styled(UICard)<{ $status: RowDisplayStatus }>(
  ({ $status }) => [
    tw`mb-8`,
    ...statusBackground($status, false),
    $status === 'past' && pastRow
  ]
);

/* The card's title and the period the booking is on for, on one line: the
   times sit at the right of the header rather than in two detail rows of
   their own */
export const CardHeader = styled.div(tw`flex items-baseline`);

/* The card's title and, beside it, how many of the resource the booking books
   ("Projector × 2"): one line that takes the room the times do not, so the
   count stays with the name rather than drifting off to the right of the
   header. It never wraps - the count keeps its place at the end of the title's
   first line, and a title too long for the card wraps within its own room
   instead. The same shape as ChildBookingLabel, which holds the two on the row
   of a set's member. */
export const CardTitleLabel = styled.div(
  tw`flex flex-1 items-baseline flex-nowrap min-w-0`
);

export const CardTitle = styled(Body)<{ $deleted: boolean }>(({ $deleted }) => [
  tw`font-bold m-0 min-w-0`,
  $deleted && deletedText
]);
